import { render, staticRenderFns } from "./ArchiveReturnPartners.vue?vue&type=template&id=6d93800d&"
import script from "./ArchiveReturnPartners.vue?vue&type=script&lang=js&"
export * from "./ArchiveReturnPartners.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveReturnPartners.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchiveReturnPartners.vue"
export default component.exports